import React from 'react';
import { HomepageShowcase } from './HomepageShowcase';
export function FeatureShowcase() {
  return <section className="w-full py-16 px-6 md:px-12 flex flex-col items-center" data-id="element-235">
      <div className="w-full max-w-5xl" data-id="element-236">
        <HomepageShowcase data-id="element-237" />
      </div>
    </section>;
}